import type { WindowFai } from '@trp-dms-pop/product-component-library-components/common';
import { UrlLoadOrchestration } from './url-load.js';
import { modifyUrlLoadedComponent } from './url-load.us-intermediary.util.js';

// The following is to pass tslint and prettier
declare global {
  interface Window {
    trp?: {
      fai?: WindowFai;
    };
  }
}

export class USIntermediaryUrlLoadOrchestration extends UrlLoadOrchestration {
  constructor() {
    super();
  }

  public createCallback(): void {
    /* Define a callback to replace the fai-beacon with beacon for the url-load component
     * Also modifying the anchor link and beacon button targets to open in a new tab.
     */
    window['urlLoadCallback'] = modifyUrlLoadedComponent;

    window['navigationXFLoadCallback'] = function (response) {
      window.setTimeout(() => {
        if (window.trp?.fai?.header?.init) {
          window.trp.fai.header.init();
        }

        document.dispatchEvent(new CustomEvent('reloadSearchComponent'));
      }, 4000);

      return response.replaceAll('fai-beacon', 'beacon');
    };
  }
}
